jQuery(document).ready(function ($) {
  var $charts = $(".graph-chart");
  if (!$charts.length) {
    return;
  }

  var reduceMotion =
    window.matchMedia &&
    window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  var mobileMq =
    window.matchMedia && window.matchMedia("(max-width: 767.98px)");

  function isMobile() {
    return !!(mobileMq && mobileMq.matches);
  }

  function polar(cx, cy, r, angle) {
    return {
      x: cx + r * Math.cos(angle),
      y: cy + r * Math.sin(angle),
    };
  }

  function slicePath(cx, cy, r, startAngle, endAngle) {
    var sweep = endAngle - startAngle;
    if (sweep <= 0.00001) {
      var p = polar(cx, cy, r, startAngle);
      return ["M", cx, cy, "L", p.x, p.y, "Z"].join(" ");
    }
    // Full (or near-full) circle needs two arcs
    if (sweep >= Math.PI * 2 - 0.001) {
      var mid = startAngle + Math.PI;
      var a = polar(cx, cy, r, startAngle);
      var b = polar(cx, cy, r, mid);
      return [
        "M",
        cx,
        cy,
        "L",
        a.x,
        a.y,
        "A",
        r,
        r,
        0,
        1,
        1,
        b.x,
        b.y,
        "A",
        r,
        r,
        0,
        1,
        1,
        a.x,
        a.y,
        "Z",
      ].join(" ");
    }
    var start = polar(cx, cy, r, startAngle);
    var end = polar(cx, cy, r, endAngle);
    var largeArc = sweep > Math.PI ? 1 : 0;
    return [
      "M",
      cx,
      cy,
      "L",
      start.x,
      start.y,
      "A",
      r,
      r,
      0,
      largeArc,
      1,
      end.x,
      end.y,
      "Z",
    ].join(" ");
  }

  function parseSegments($chart) {
    try {
      var data = JSON.parse($chart.attr("data-segments") || "[]");
      return Array.isArray(data) ? data : [];
    } catch (e) {
      return [];
    }
  }

  function runSequence(tasks) {
    return tasks.reduce(function (chain, task) {
      return chain.then(task);
    }, Promise.resolve());
  }

  function initPie($chart) {
    var segments = parseSegments($chart);
    if (!segments.length) {
      return;
    }

    var svg = $chart.find(".graph-pie__svg")[0];
    if (!svg) {
      return;
    }

    var mobile = isMobile();
    $chart.data("graphPieMobile", mobile);

    var NS = "http://www.w3.org/2000/svg";
    // Mobile: clean pie only (legend below). Desktop: pie + callout labels.
    var vbW = mobile ? 400 : 640;
    var vbH = mobile ? 400 : 360;
    var cx = vbW / 2;
    var cy = vbH / 2;
    var radius = mobile ? Math.round(vbW * 0.4) : 148; // diameter = 80% on mobile
    var elbowPad = 18;
    var labelPad = 78;

    svg.setAttribute("viewBox", "0 0 " + vbW + " " + vbH);

    while (svg.firstChild) {
      svg.removeChild(svg.firstChild);
    }

    var base = document.createElementNS(NS, "circle");
    base.setAttribute("class", "graph-pie__base");
    base.setAttribute("cx", String(cx));
    base.setAttribute("cy", String(cy));
    base.setAttribute("r", String(radius));
    svg.appendChild(base);

    var slicesGroup = document.createElementNS(NS, "g");
    slicesGroup.setAttribute("class", "graph-pie__slices");
    svg.appendChild(slicesGroup);

    var calloutsGroup = null;
    if (!mobile) {
      calloutsGroup = document.createElementNS(NS, "g");
      calloutsGroup.setAttribute("class", "graph-pie__callouts");
      svg.appendChild(calloutsGroup);
    }

    var $legendItems = $chart.find(".graph-pie-legend__item");
    $legendItems.removeClass("is-visible");

    var totalPercent = segments.reduce(function (sum, seg) {
      return sum + (Number(seg.percent) || 0);
    }, 0);
    if (totalPercent <= 0) {
      return;
    }

    var startAngle = -Math.PI / 2;
    var sliceMeta = [];

    segments.forEach(function (seg, index) {
      var sweep = ((Number(seg.percent) || 0) / totalPercent) * Math.PI * 2;
      var endAngle = startAngle + Math.max(sweep, 0.0001);
      var mid = startAngle + (endAngle - startAngle) / 2;
      var color = seg.color || "#E00034";

      var path = document.createElementNS(NS, "path");
      path.setAttribute("class", "graph-pie__slice");
      path.setAttribute("fill", color);
      path.setAttribute("d", slicePath(cx, cy, radius, startAngle, startAngle));
      slicesGroup.appendChild(path);

      var callout = null;
      if (!mobile && calloutsGroup) {
        var onRight = Math.cos(mid) >= 0;
        var dot = polar(cx, cy, radius * 0.82, mid);
        var elbow = polar(cx, cy, radius + elbowPad, mid);
        var labelX = onRight ? elbow.x + labelPad : elbow.x - labelPad;
        var anchor = onRight ? "start" : "end";

        callout = document.createElementNS(NS, "g");
        callout.setAttribute("class", "graph-pie__callout");
        callout.setAttribute("data-index", String(index));

        var line = document.createElementNS(NS, "polyline");
        line.setAttribute("class", "graph-pie__callout-line");
        line.setAttribute(
          "points",
          [dot.x, dot.y, elbow.x, elbow.y, labelX, elbow.y].join(" ")
        );
        callout.appendChild(line);

        var dotEl = document.createElementNS(NS, "circle");
        dotEl.setAttribute("class", "graph-pie__callout-dot");
        dotEl.setAttribute("cx", String(dot.x));
        dotEl.setAttribute("cy", String(dot.y));
        dotEl.setAttribute("r", "3.5");
        callout.appendChild(dotEl);

        var title = document.createElementNS(NS, "text");
        title.setAttribute("class", "graph-pie__callout-title");
        title.setAttribute("x", String(labelX));
        title.setAttribute("y", String(elbow.y - 3));
        title.setAttribute("text-anchor", anchor);
        title.textContent = seg.title || "";
        callout.appendChild(title);

        var value = document.createElementNS(NS, "text");
        value.setAttribute("class", "graph-pie__callout-value");
        value.setAttribute("x", String(labelX));
        value.setAttribute("y", String(elbow.y + 3));
        value.setAttribute("text-anchor", anchor);
        value.textContent = seg.display || "";
        callout.appendChild(value);

        calloutsGroup.appendChild(callout);
      }

      sliceMeta.push({
        path: path,
        callout: callout,
        legendItem: $legendItems.get(index) || null,
        startAngle: startAngle,
        endAngle: endAngle,
      });

      startAngle = endAngle;
    });

    function revealMeta(meta) {
      if (meta.callout) {
        meta.callout.classList.add("is-visible");
      }
      if (meta.legendItem) {
        meta.legendItem.classList.add("is-visible");
      }
    }

    function showFinal() {
      base.classList.add("is-visible");
      sliceMeta.forEach(function (meta) {
        meta.path.setAttribute(
          "d",
          slicePath(cx, cy, radius, meta.startAngle, meta.endAngle)
        );
        revealMeta(meta);
      });
    }

    function fadeInBase() {
      return new Promise(function (resolve) {
        if (reduceMotion) {
          base.classList.add("is-visible");
          resolve();
          return;
        }
        // Force a reflow so the opacity transition always plays
        void base.getBoundingClientRect();
        base.classList.add("is-visible");
        window.setTimeout(resolve, 550);
      });
    }

    function animateSlice(meta, duration) {
      return new Promise(function (resolve) {
        if (reduceMotion) {
          meta.path.setAttribute(
            "d",
            slicePath(cx, cy, radius, meta.startAngle, meta.endAngle)
          );
          revealMeta(meta);
          resolve();
          return;
        }

        // Reveal callout / legend row as the slice starts filling
        revealMeta(meta);

        var start = null;
        function frame(ts) {
          if (start === null) {
            start = ts;
          }
          var t = Math.min(1, (ts - start) / duration);
          var eased = 1 - Math.pow(1 - t, 3);
          var angle =
            meta.startAngle + (meta.endAngle - meta.startAngle) * eased;
          meta.path.setAttribute(
            "d",
            slicePath(cx, cy, radius, meta.startAngle, angle)
          );
          if (t < 1) {
            window.requestAnimationFrame(frame);
          } else {
            resolve();
          }
        }
        window.requestAnimationFrame(frame);
      });
    }

    function run() {
      var tasks = [
        function () {
          return fadeInBase();
        },
      ].concat(
        sliceMeta.map(function (meta) {
          return function () {
            var sweep = meta.endAngle - meta.startAngle;
            var duration = Math.max(220, Math.min(520, 180 + sweep * 180));
            return animateSlice(meta, duration);
          };
        })
      );
      return runSequence(tasks);
    }

    $chart.data("graphRun", run);
    $chart.data("graphShowFinal", showFinal);
  }

  function initBar($chart) {
    var $bars = $chart.find(".graph-bar");
    if (!$bars.length) {
      return;
    }

    function showFinal() {
      $bars.addClass("is-filled");
    }

    function animateBar($bar) {
      return new Promise(function (resolve) {
        $bar.addClass("is-filled");
        window.setTimeout(resolve, reduceMotion ? 0 : 420);
      });
    }

    function run() {
      if (reduceMotion) {
        showFinal();
        return Promise.resolve();
      }
      var tasks = [];
      $bars.each(function (i) {
        var $bar = $(this);
        tasks.push(function () {
          return new Promise(function (resolve) {
            window.setTimeout(function () {
              animateBar($bar).then(resolve);
            }, i === 0 ? 0 : 80);
          });
        });
      });
      return runSequence(tasks);
    }

    $chart.data("graphRun", run);
    $chart.data("graphShowFinal", showFinal);
  }

  function observe($chart) {
    if (reduceMotion || !("IntersectionObserver" in window)) {
      var showFinal = $chart.data("graphShowFinal");
      if (typeof showFinal === "function") {
        showFinal();
      } else {
        var runImmediate = $chart.data("graphRun");
        if (typeof runImmediate === "function") {
          runImmediate();
        }
      }
      return;
    }

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting || $chart.data("graphPlayed")) {
            return;
          }
          $chart.data("graphPlayed", true);
          observer.unobserve(entry.target);
          var run = $chart.data("graphRun");
          if (typeof run === "function") {
            run();
          }
        });
      },
      { threshold: 0.35 }
    );

    $chart.data("graphObserver", observer);
    observer.observe($chart[0]);
  }

  function setupChart($chart) {
    var type = $chart.attr("data-chart-type");
    if (type === "bar") {
      initBar($chart);
    } else {
      initPie($chart);
    }
  }

  $charts.each(function () {
    var $chart = $(this);
    setupChart($chart);
    observe($chart);
  });

  // Rebuild pie when crossing the mobile breakpoint
  if (mobileMq) {
    var onBreakpoint = function () {
      $charts.filter('[data-chart-type="pie"]').each(function () {
        var $chart = $(this);
        var mobile = isMobile();
        if ($chart.data("graphPieMobile") === mobile) {
          return;
        }
        var played = !!$chart.data("graphPlayed");
        initPie($chart);
        if (played) {
          var showFinal = $chart.data("graphShowFinal");
          if (typeof showFinal === "function") {
            showFinal();
          }
        }
      });
    };

    if (typeof mobileMq.addEventListener === "function") {
      mobileMq.addEventListener("change", onBreakpoint);
    } else if (typeof mobileMq.addListener === "function") {
      mobileMq.addListener(onBreakpoint);
    }
  }
});
